import { Component, OnInit } from "@angular/core";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICustomer } from "../../../customer.interface";
import { AuthenticationService } from "../../../../../auth/service";
import { environment } from "../../../../../../environments/environment";
import { CustomerService } from "../../../customer.service";

@Component({
  selector: "app-customers-list",
  templateUrl: "./customers-list.component.html",
  styleUrls: ["./customers-list.component.scss"],
})
export class CustomersListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  private customers: ICustomer[] = [];
  public filteredCustomers: ICustomer[] = [];
  public searchKey: string = "";
  public tableLimit: number = 10;

  constructor(
    public _utilService: UtilsService,
    public customerService: CustomerService,
    public _authenticationService: AuthenticationService,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.CUSTOMERS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.CUSTOMERS",
            isLink: false,
          },
          {
            name: "LIST",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    await this.loadCustomers();
  }

  async loadCustomers() {
    this.customers = await this.customerService.getCustomers().then((customers: ICustomer[]) => {
      return customers.map((customer: ICustomer) => {
        if (customer.logo) {
          customer.logo = environment.CDN_URL + "/" + customer.logo;
        }
        return customer;
      });
    });
    await this.search();
  }

  updateTableLimit(event: any) {
    this.tableLimit = Number(event.target.value);
  }

  async delete(customer: ICustomer) {
    if (!this._authenticationService.hasCapability("delete_customer")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${customer.name}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.customerService
            .deleteCustomer(customer.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this.loadCustomers();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_CUSTOMER" });
              await this.loadCustomers();
              await this.search();
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER" });
      });
  }

  async search() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredCustomers: ICustomer[] = this.customers;
    if (key.length > 0) {
      filteredCustomers = filteredCustomers.filter((item: ICustomer) => {
        return item.business_name.toLowerCase().includes(key) || item.name.toLowerCase().includes(key);
      });
    }
    this.filteredCustomers = filteredCustomers;
  }
}
